import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';
import Keyboard from 'simple-keyboard';
import KeyboardLayouts from 'simple-keyboard-layouts';

@Component({
  selector: 'app-single-select-dropdown',
  templateUrl: './single-select-dropdown.component.html',
  styleUrls: ['./single-select-dropdown.component.scss']
})
export class SingleSelectDropdownComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:''
  }
  @ViewChild('simpleKeyboardRef', {static:false}) simpleKeyboardRef: ElementRef | undefined;
  @ViewChild('input', {static:false}) inputRef: ElementRef | undefined;
  @ViewChild('searchDataRef', {static:false}) searchDataRef: ElementRef | undefined;
  public keyboard: Keyboard | undefined;
  public isKeyboardReInstanciated : boolean =false;
  public keyword:string = 'name';
  public keyboardLayouts: any;
  public filterCityArr:any = [];
  public filterdData:any = [];
  layoutsObj: any;
  selectedLayout: string = 'english';
  value = '';
  // searchTxtCatch= '';
  public focusShow:boolean=false;
  public componentType:string = "";
  constructor(public qService:QuestionService, 
    public aService:AnswerService,
    public notifier: NotifierService,
    private renderer: Renderer2) { 
      this.componentType = this.qService.questionType.SINGLE_SELECT_DROPDOWN
      this.qService.refreshAnsBody
      .subscribe((question_type:string) =>{
        if (question_type == this.componentType) {
          this.resetAnsBody();
        }
      })
      this.keyboardLayouts = new KeyboardLayouts();
      this.layoutsObj = this.keyboardLayouts.get();
  }

  ngOnInit(): void {
    this.getFilterArray();
  }

  selectOption(value:any){
    this.ansBody.question_label = this.qService.currentQuestion.question_label;
    this.ansBody.answer_text = this.aService.selectedCity;

  }
  getFilterArray(){
    let city_arr = this.qService.currentQuestion.options;
    city_arr = city_arr.sort((one: number, two: number) => (one > two ? 1 : -1));
    this.filterCityArr = city_arr?.map((city:string,index:number) => ({'id':index+1,'name':city}));
  }

  next(){
    this.ansBody.question_label = this.qService.currentQuestion.question_label;
    this.ansBody.question_name = this.qService.currentQuestion.question_name;
    if (!this.ansBody.answer_text || this.ansBody.answer_text == '') {
      this.notifier.notify('error',"Please select a value");
      return;
    }
    this.aService.submitAnswer(this.ansBody);
    // this.resetAnsBody();
    // setTimeout(() => {
    //   this.resetAnsBody();
    // }, 100);
  }
  selectEvent(item:any) {
    this.ansBody.answer_text = item.name;
    // do something with selected item
  }

  onChangeSearch(search: string) {
    console.log("keyword is ",this.keyword)
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e:any) {
    // do something
  }

  onFocusIn(){
    this.focusShow = this.checkInputFocus();
  }

  checkInputFocus(){
    if (this.filterdData && this.filterdData.length) {
      return true
    }else{
      return false
    }
  }

  onFocusOut(){
    this.renderer.listen('window', 'click',(e:Event)=>{
      if (this.searchDataRef && this.simpleKeyboardRef) {
        if(e.target !== this.searchDataRef.nativeElement && e.target !== this.simpleKeyboardRef.nativeElement && !this.searchDataRef.nativeElement.contains(e.target) && !this.simpleKeyboardRef.nativeElement.contains(e.target)){
          this.focusShow = false;
        }
      }
    });
    // console.log("onFocusOut");
    // setTimeout(() => {
    //   this.focusShow = false;
    // }, 500);
  }

  onOpenKeyboard() {
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    // this.focusShow = true;
    this.focusShow = this.checkInputFocus();
    this.selectedLayout = 'english';
    this.isKeyboardReInstanciated = true;
    this.keyboard = new Keyboard(".simple-keyboard",{
      onChange: input => this.onChange(input),
      onKeyPress: (button: any) => this.onKeyPress(button),
      layout: {
        default: [this.layoutsObj[this.selectedLayout].layout.default][0],
        shift: [this.layoutsObj[this.selectedLayout].layout.shift][0],
        numeric: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],
        decimal: ['1 2 3', '4 5 6', '7 8 9', '.00 0 .', '{bksp} {enter}'],
      },
      buttonTheme: [
        {
          class: 'hg-enter',
          buttons: '{enter}',
        },
      ],
      display: {
        '{enter}': '↩',
        '{bksp}': '⌫',
        '{space}': ' ',
        '{shift}': '⇪',
        '{lock}': '🄰',
        '{tab}': '⇄',
      },
    });

    if (this.qService.currentQuestion.misc && this.qService.currentQuestion.misc.ans_type && this.qService.currentQuestion.misc.ans_type == "numeric") {
      this.keyboard.setOptions({
        inputName: 'numericInput',
        layoutName: 'numeric',
      });
    }

    if (this.keyboard && this.value!= '') {
      this.keyboard.setInput(this.value);
    }

    // this.keyboard.setOptions({
    //   theme: "dark"
    // });
    // console.log("onOpenKeyboard this.keyboard",this.keyboard);
  }

  onCloseKeboard(){
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    this.isKeyboardReInstanciated = false;
    this.focusShow = false;
  }
    
  onChange = (input: string) => {
    this.value = input;
    // this.focusShow = true;
    this.filterCity();
    // this.ansBody.answer_text = this.value;
  };


  onKeyPress = (button: string) => {
    if (button === '{shift}' || button === '{lock}') this.handleShift();
  };

  onInputChange = (event: any) => {
    if (this.keyboard) {
      this.keyboard.setInput(event.target.value);
    }
    this.value = event.target.value;
    // this.focusShow = true;
    // this.onFocusIn();
    this.filterCity();
    // console.log(this.value,"this.focusShow  ",this.focusShow )
    // this.ansBody.answer_text = event.target.value;
  }

  handleShift = () => {
    if (this.keyboard) {
      let currentLayout = this.keyboard.options.layoutName;
      // console.log("this.keyboard.options.layoutName ",this.keyboard.options.layoutName)
      let shiftToggle = currentLayout === "default" ? "shift" : "default";
  
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
   
    }
  };

  selectCity(city:any){
    // console.log("city is", city)
    if (city && city.id > -1) {
      this.ansBody.answer_text = city.name;
      if (this.keyboard) {
        this.keyboard.setInput(city.name);
      }
      this.value = city.name;
      this.focusShow = false;
    }
  }

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:'',
    }
  }

  filterCity(){
    this.filterdData;
    let searchTxt = this.value;
    if (searchTxt && searchTxt.length  && searchTxt.length >= 1) {

      this.filterdData = this.filterCityArr.filter((value:any, index:number) =>{
        if(value.name.toUpperCase().indexOf(searchTxt.toUpperCase()) > -1 ) {
          return this.filterCityArr[index];
        }
      })
      // this.filterdData = this.filterCityArr.filter((value:any, index:number) =>{
      //   if(value.name.toUpperCase().startsWith(searchTxt.toUpperCase())) {
      //     return this.filterCityArr[index];
      //   }
      // });
    }
    // else if(searchTxt.length < 3 && searchTxt.length > 0){
    //   this.filterdData;
    // }
    else{
      // this.searchTxtCatch = "";
      this.filterdData = [];
    }

    if (this.filterdData && this.filterdData.length > 0) {
      this.filterdData;
    }
    else if(searchTxt.length < 1){
      this.filterdData = [];
    }
    else{
      this.filterdData = [{"name":"Not Found", "id":-1}];
    }
    this.focusShow = this.checkInputFocus();
  }
}
